var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/ic_shortcut_coupon.59c780ec.png","uri@2x": __webpack_public_path__ + "static/media/ic_shortcut_coupon.e40f929d.png","uri@3x": __webpack_public_path__ + "static/media/ic_shortcut_coupon.c8ae7cb4.png",
    width: 24,
    height: 24
});